
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class WattMinModal extends Vue {

    @Prop({
        default: () => new OM.WattMinModel()
    }) model: OM.WattMinModel;

    localModel: OM.WattMinModel = new OM.WattMinModel();

    @Prop() callback: any;

    created() {
        this.localModel = this.model;
    }

    get canSave(){
        return this.localModel.watt.key && this.localModel.minutes.key;
    }

    save() {
        if(!this.canSave)
            return;

        this.callback(this.localModel);
    }
    
}
